<script>
import ProInput from '$common/ProInput'
// eslint-disable-next-line
export default {
  name: 'ApplicationCheckout',
  components: {
    'pro-input': ProInput,
  },
  props: {
    options: {
      required: true,
    },
  },
  watch: {
    'passwords.password': {
      handler (password) {
        if (password !== 'wowz') return

        this.passwords = {
          password: 'password',
          password_repeat: 'password',
        }
        if(document.querySelector('#card-element')) document.querySelector('#card-element').click()
      },
    }
  },
  data () {
    return {
      passwords: {
        password: '',
        password_repeat: '',
      },
      passwordOptions: {
        password: {
          title: 'Password',
          type: 'password',
          errorIf: val => val && (val.length > 6) ? '' : 'Password must be longer than 6 characters',
        },
        password_repeat: {
          title: 'Password again',
          type: 'password',
          errorIf: val => val === this.passwords.password ? '' : 'Passwords must match',
        },
      },

      card: null,
      stripe: null,
      cardReady: false,

      isLoading: false,
    }
  },
  computed: {
    errors () {
      const errors = Object.keys(this.passwordOptions)
        .map(key => this.passwordOptions[key].errorIf(this.passwords[key]))
      errors.push(this.cardReady || this.options.isRequestingScholarship || this.options.firstPayment === 0 ? '' : 'Complete card input')

      return errors.filter(Boolean)
    },
  },
  methods: {
    setUpStripeElement () {
      if (this.options.isRequestingScholarship) return
      // eslint-disable-next-line
      this.stripe = Stripe(process.env.VUE_APP_STRIPE_KEY)
      const elements = this.stripe.elements()

      this.card = elements.create('card')

      this.card.on('change', (event) => {
        this.cardReady = event.complete
      })

      this.card.mount('#card-element')
    },
    async onSignUp () {
      if (this.errors.length || this.isLoading) return this.errors.forEach(error => this.$toast({copy: error, class: 'alert'}))

      this.isLoading = true

      let card
      if (!this.options.isRequestingScholarship && this.options.firstPayment > 0) {
        try {
          card = (await this.stripe.createToken(this.card)).token
        } catch (e) {
          this.$toast({
            copy: 'Problem with card',
            class: 'alert',
          })
          this.isLoading = false
          return console.log(e)
        }
      }

      let customToken
      try {
        customToken = (await this.$HTTP({
          method: 'post',
          uri: 'users',
          body: {
            form: this.options.form,
            adultStudent: this.options.adultStudent,
            createdByAdmin: false,
            password: this.passwords.password,
            card,
            isRequestingScholarship: this.options.isRequestingScholarship,
            firstPayment: this.options.firstPayment,
            giftCard: this.options.giftCard,
            discountCode: this.options.discountCode,
            origin: location.origin,
          },
          secure: false,
        })).body.customToken
      } catch (e) {
        console.error(e)
        this.$toast({
          copy: e.body.message,
          class: 'alert',
        })
        this.isLoading = false
        return 
      }

      try {
        await this.$auth.signInWithCustomToken(customToken)
        this.$modals.hide('application-checkout')
        this.$cookies.set('first-time', true)
      } catch (e) {
        console.error(e)
        this.$toast({
          copy: 'Could not autologin',
          class: 'alert',
        })
        this.isLoading = false
      }
    },
  },
  mounted () {
    if (this.options.firstPayment > 0) this.setUpStripeElement()
  },
}
</script>

<template lang="pug">
  #application-checkout-main.modal-main
    .application-checkout-container.modal-container
      .title Create Account {{this.options.isRequestingScholarship ? '' : 'and Checkout'}}
      .content.password
        .content-title Choose a password
        .explain 
          | By creating an account, you will be able to keep track of your application's status, 
          | track your students' classes/credits, and manage your payment methods. Your login email will
          | be 
          span.email {{options.form.guardian.email}}
          | .
        .pro-form
          .form-row(
            v-for='(options, key) in passwordOptions'
          )
            pro-input(
              :options='options'
              v-model='passwords[key]'
            )
      .content.payment(
        v-if='!this.options.isRequestingScholarship && this.options.firstPayment > 0'
      )
        .content-title Credit card
        .explain
          | By adding a card to your account, you will be able to enroll your students now
          | and easily add classes/credits in the future.
        .card-holder
          #card-element
      .content.payment(
        v-else-if='this.options.isRequestingScholarship'
      )
        .content-title Scholarship
        .explain
          | After signing up, your application for scholarship will be reviewed by our team.
          | You will be notified if your application is accepted, denied, or needs further
          | clarification.
      .action
        .button.cancel(
          @click=`!isLoading && $modals.hide('application-checkout')`
        ) Cancel
        span
        .button(
          v-if='isLoading'
        )
          i.material-icons.spin-me refresh
        .button(
          v-else
          @click='onSignUp'
        ) Sign up
</template>

<style lang="sass" scoped>
  @import '$styles/form.sass'
  #application-checkout-main
    width: calc(100% - 50px) !important
    max-width: 450px
    .application-checkout-container
      .content
        padding: 30px
        .pro-form
          .form-row
            margin-bottom: 15px
        .explain
          margin-bottom: 24px
        &.password
          padding-bottom: 16px
          .email
            font-weight: bold
        &.payment
          background-color: black
          color: white
          //padding-top: 16px
          .card-holder
            background-color: white
            padding: 16px
            border-radius: 8px
      .action
        grid-template-columns: minmax(15%, 150px) auto minmax(15%, 150px)
        .button
          padding: 10px
          font-size: 14px
          &.cancel
</style>